import { FC } from 'react';

import { StyledSpinner } from './styles';

interface ISpinnerProps {
  readonly size?: number;
}

export const Spinner: FC<ISpinnerProps> = ({ size = 50 }) => {
  return <StyledSpinner size={size} />;
};
